module.exports = function manhattan(a, b) {
    var i = 0,
        ii = a.length,
        d = 0;
    for (; i < ii; i++) {
        d += Math.abs(a[i] - b[i]);
    }
    return d;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-distance/src/distances/manhattan.js
 ** module id = 56
 ** module chunks = 0
 **/